import type { SVGProps } from "react";

// Clyde's mark: a cowboy hat tipped toward you, drawn on lucide's grid so it sits
// with the nav's other icons — 24 × 24 viewBox, 2px round stroke, currentColor, no
// fill. Sized like a lucide icon, by className (h-4 w-4 in the nav).
export function CowboyHatIcon({ className = "h-4 w-4", ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...props}
    >
      {/* Tipped 15° — the hat lifted to someone in acknowledgement. */}
      <g transform="rotate(-15 12 12)">
        {/* Crown, pinched at the top */}
        <path d="M6.5 14.5c0-3.2.6-6 1.7-7.8.7-1.1 2-1.3 2.9-.5l.9.8.9-.8c.9-.8 2.2-.6 2.9.5 1.1 1.8 1.7 4.6 1.7 7.8" />
        {/* Brim, curled up at both ends */}
        <path d="M2 11.5c1 2.4 3 4 5.2 4.5 1.5.3 3.1.5 4.8.5s3.3-.2 4.8-.5c2.2-.5 4.2-2.1 5.2-4.5" />
      </g>
    </svg>
  );
}
